import { render, staticRenderFns } from "./instantPayment.vue?vue&type=template&id=52194afb&scoped=true"
import script from "./instantPayment.vue?vue&type=script&lang=js"
export * from "./instantPayment.vue?vue&type=script&lang=js"
import style0 from "./instantPayment.vue?vue&type=style&index=0&id=52194afb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52194afb",
  null
  
)

export default component.exports